import { useEffect, useState } from 'react'

type TypeOptions = {
  onVisible?: () => void
  onInvisible?: () => void
  observerInit?: IntersectionObserverInit
}
// research - регулярный поиск элемента, поддержание (на случай если обновится или пропадет)
export const useIntersection = (elemOrSelector: string | Element, options?: TypeOptions, research?: boolean) => {
  const [isVisible, setIsVisible] = useState(false)
  const [elem, setElement] = useState(null)

  const optionsObserver: IntersectionObserverInit = {
    root: null,
    rootMargin: '5px',
    threshold: 0.5,
    ...options?.observerInit,
  }

  useEffect(() => {
    if (!elemOrSelector) return

    if (typeof elemOrSelector === 'string') {
      const findElement = () => {
        const el = document.querySelector(elemOrSelector)
        if (el && !research) {
          setElement(el)
          return
        }
        if (el && research) {
          setElement(el)
        }
        setTimeout(findElement, el ? 500 : 200) // Проверяем каждые 200мс
      }
      findElement()
      // @ts-ignore
      return () => clearTimeout(findElement)
    } else if (typeof elemOrSelector === 'object') {
      setElement(elemOrSelector)
    }
  }, [elemOrSelector])

  useEffect(() => {
    if (!elem) return

    const target = elem
    const callbackObserver = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          options?.onVisible && options?.onVisible()
          setIsVisible(true)
        } else {
          options?.onInvisible && options?.onInvisible()
          setIsVisible(false)
        }
      })
    }

    const observer = new IntersectionObserver(callbackObserver, optionsObserver)
    observer.observe(target)

    return () => {
      observer.unobserve(target)
      setIsVisible(false)
    }
  }, [elem])

  return isVisible
}
